module.exports = __webpack_public_path__ + "static/img/celestion.bb7ed70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fx-software/pack/celestion.png
// module id = zW6e
// module chunks = 13